@if (loading) {
  <div style="max-height: none; margin-top: 1rem; position: relative">
    <div>
      <pr-loader style="max-height: 0rem; margin-top: 7rem"></pr-loader>
      <p class="loader-documents-message">Chargement de la tarification...</p>
    </div>
  </div>
}
@if (loadingDownloadDocuments) {
  <div style="max-height: none; margin-top: 1rem; position: relative">
    <div>
      <pr-loader style="max-height: 0rem; margin-top: 7rem"></pr-loader>
      <p class="loader-documents-message">Téléchargement du document...</p>
    </div>
  </div>
}
<form (ngSubmit)="onSubmit()" [formGroup]="form" class="form">
  <form-wrapper>
    <ng-container formArrayName="products">
      @for (product of products.controls; track product; let index = $index) {
        @if (index == 0) {
          <ng-container [formGroup]="product">
            <ng-container formGroupName="parameters">
              @if (!loading && !loadingDownloadDocuments) {
                <div class="tarif-config card">
                  <h3 class="config-title">Configuration de la tarification</h3>
                  <div class="config-grid">
                    <!-- Type de cotisations -->
                    <div class="config-item">
                      <pr-input-radio
                        [toggleBgEmpty]="true"
                        formControlName="premiumType"
                        label="Type de cotisations"
                        [options]="[
                          { value: 'CI', label: 'CI' },
                          { value: 'CRD', label: 'CRD' },
                        ]"
                      >
                      </pr-input-radio>
                    </div>
                    <!-- Frais de dossier -->
                    <div class="config-item">
                      <pr-input-column
                        label="Frais de dossier"
                        [derrors]="derrors"
                        [suffix]="'€'"
                      >
                        <input
                          formControlName="applicationFee"
                          type="text"
                          placeholder="200"
                        />
                      </pr-input-column>
                    </div>
                    <!-- Lissage des frais -->
                    <div class="config-item">
                      <pr-input-column
                        label="Lissage des frais"
                        [derrors]="derrors"
                      >
                        <mat-select formControlName="smoothingFeesDuration">
                          @for (
                            option of smoothingFeesDurationRef;
                            track option
                          ) {
                            <mat-option [value]="option.id">
                              {{ option.label }}
                            </mat-option>
                          }
                        </mat-select>
                      </pr-input-column>
                    </div>
                    <!-- Code génération DI -->
                    <div class="config-item">
                      <pr-input-column
                        label="Code génération Digital Insure"
                        [derrors]="derrors"
                      >
                        <mat-select formControlName="commDerogCode">
                          @for (option of codeConfiguration; track option) {
                            <mat-option [value]="option">
                              {{ option }}
                            </mat-option>
                          }
                        </mat-select>
                      </pr-input-column>
                    </div>
                  </div>
                  <!-- Bouton regénération -->
                  <div class="config-actions">
                    <pr-button
                      size="lg"
                      display="neutral"
                      (onClick)="regenerateTarification()"
                      label="Regénérer la tarification"
                    />
                  </div>
                </div>
              }
              @if (!loading && !loadingDownloadDocuments) {
                <div
                  formArrayName="tarifications"
                  class="container-tarification-table"
                >
                  <table class="table-bordered table w-full">
                    <thead>
                      <tr>
                        <th></th>
                        <th>Logo</th>
                        <th>Nom</th>
                        <th>Coût total</th>
                        <th>Mensualité</th>
                        <th>Coût sur 8 ans</th>
                        <th>TMA</th>
                        <th>Info</th>
                        <th><i class="fa fa-download"></i></th>
                      </tr>
                    </thead>
                    <tbody>
                      @for (
                        tarif of tarifications.controls;
                        track tarif;
                        let i = $index
                      ) {
                        <tr
                          [formGroupName]="i"
                          (click)="
                            toggleTarification(tarif.get('product.code').value)
                          "
                          [ngClass]="{
                            'row-tarification': true,
                            'row-tarification-selected':
                              product
                                .get('parameters')
                                .get('choosedProductCode').value ===
                              tarif.get('product.code').value,
                          }"
                        >
                          <!-- bouton radio pour indiquer la sélection -->
                          <td class="text-center">
                            <input
                              type="radio"
                              name="choosedProduct"
                              [checked]="
                                product
                                  .get('parameters')
                                  .get('choosedProductCode').value ===
                                tarif.get('product.code').value
                              "
                              class="radio-select"
                            />
                          </td>
                          <!-- logo -->
                          <td>
                            <img
                              [src]="tarif.get('product.logo').value"
                              alt="Product Image"
                              class="di-logo-table"
                            />
                          </td>
                          <!-- code produit -->
                          <td>
                            {{ tarif.get('product.code').value }}
                          </td>
                          <!-- coût total -->
                          <td>
                            {{
                              tarif.get('coutTotal').value | number: '1.0-2'
                            }}
                            €
                          </td>
                          <!-- mensualité -->
                          <td>
                            {{
                              tarif.get('mensualite').value | number: '1.0-2'
                            }}
                            €
                          </td>
                          <!-- coût sur 8 ans -->
                          <td>
                            {{
                              tarif.get('coutSur8Ans').value | number: '1.0-2'
                            }}
                            €
                          </td>
                          <!-- TMA -->
                          <td>
                            {{ tarif.get('tma').value | number: '1.0-2' }} %
                          </td>
                          <!-- bouton infos (key points) -->
                          <td class="text-center">
                            <div
                              class="icon-key-points"
                              (click)="onKeyPointsClick($event, tarif)"
                            >
                              <pr-icon
                                name="sp-lightbulb"
                                [width]="20"
                                [viewBoxWidth]="20"
                                [viewBoxHeight]="20"
                              ></pr-icon>
                            </div>
                          </td>
                          <td class="box-download-links">
                            <p
                              class="download-text"
                              (click)="onDownloadLinks($event, tarif, 'DEVIS')"
                            >
                              Projet
                            </p>
                            <p
                              class="download-text"
                              (click)="
                                onDownloadLinks(
                                  $event,
                                  tarif,
                                  'GENERAL_CONDITIONS'
                                )
                              "
                            >
                              Notice
                            </p>
                          </td>
                        </tr>
                      }
                    </tbody>
                  </table>
                </div>
              }
            </ng-container>
          </ng-container>
        }
      }
    </ng-container>
  </form-wrapper>
  <form-footer (prev)="prev()" (next)="onSubmit()"></form-footer>
</form>

<pr-modal-confirm
  display="warning"
  title="En savoir plus"
  labelConfirm="Fermer"
  labelCancel="Retour"
  (onConfirm)="confirmModal()"
>
  <ul>
    @for (keyPoint of productSelectedKeyPoints; track keyPoint) {
      <li class="di-info-product mb-1">
        {{ keyPoint.title }} :
        <span class="di-label-product">{{ keyPoint.content }}</span>
      </li>
    }
  </ul>
</pr-modal-confirm>
